<!-- [コンテンツ領域] -->
<div class="l-core-contents__inner l-core-contents__inner--full">
  <!-- [コンテンツ領域フルカラム−メイン] -->
  <div class="l-core-contents__main">
    <!-- 検索結果操作部 start -->
    <div class="l-section">
      <asw-search-result-function
        [isShowFilter]="isShowFilter"
        [isShowSort]="isShowSort"
        [isShowCalendar]="isShowCalendar"
        [selectedCabinClass]="this.selectedCabinClass"
        [selectedFareOptionType]="this.selectedFareOptionType"
        [isShowFavorite]="isShowFavorite"
        [cffListLength]="this.cffListLength"
        [isDomesticTrip]="this.isDomesticTrip"
        (clickFilterEvent)="this.openFilterConditionModal()"
        (clickSortEvent)="this.openSortConditonModal()"
        (clickCabinClassEvent)="this.openCabinClassModal()"
        (clickFareOptionTypeEvent)="this.openFareOptionTypeModal()"
        (clickCalendarEvent)="this.openCheapestCalendarMatrixModal()"
        (clickFavoriteEvent)="this.addFavorite()"
      ></asw-search-result-function>
    </div>
    <!-- 検索結果操作部 end -->

    <!-- 搭乗者人数 start -->
    <div class="l-section u-mt-pc-32">
      <div class="c-passenger-display">
        <span class="c-passenger-display__passenger">
          {{ this.travelersLabel }}
        </span>
      </div>
    </div>
    <!-- 搭乗者人数 end -->

    <!-- 区間の描画ループ -->
    <!-- バウンドリスト start -->
    <ng-container *ngFor="let bound of this.showPropsList; index as boundIndex">
      <div class="l-section u-mt-pc-24">
        <!-- バウンドヘッダ start -->
        <div class="p-flight-bound">
          <!-- バウンド番号 -->
          <div class="p-flight-bound__heading">
            <div class="p-flight-bound__heading-title">
              <h2
                class="c-bound-title01"
                [innerHTML]="'label.number.section.n' | staticMsg : { '0': boundIndex + 1 }"
              ></h2>
            </div>
          </div>

          <div class="p-flight-bound__bound">
            <span class="p-flight-bound__fromto">
              <!-- 出発地 -->
              <span class="p-flight-bound__fromto-from">{{ bound.boundHeader?.departureAirport }}</span>
              <span class="p-flight-bound__fromto-separator" [innerHTML]="'label.section' | staticMsg"></span>
              <!-- 到着地 -->
              <span class="p-flight-bound__fromto-to">{{ bound.boundHeader?.arrivalAirport }}</span>
            </span>
          </div>

          <!-- 乗継地 -->
          <ng-container
            *ngIf="
              bound.boundHeader && bound.boundHeader.transitAirport && bound.boundHeader.transitAirport.length !== 0
            "
          >
            <ng-container *ngFor="let transitAirport of bound.boundHeader.transitAirport">
              <div
                class="p-flight-bound__via"
                [innerHTML]="'label.oneStopFlightLocation' | staticMsg : { '0': transitAirport }"
              ></div>
            </ng-container>
          </ng-container>
        </div>
        <!-- バウンドヘッダ end -->

        <!-- 未選択の場合 -->
        <ng-container *ngIf="!bound.isShowSelectedTsAndFf">
          <!-- 7日間カレンダー start -->
          <div
            class="c-result-date-navi c-result-date-navi--in-main"
            [attr.aria-label]="'reader.7daysCalendarSection' | staticMsg"
          >
            <div class="c-result-date-navi__view">
              <div class="c-result-date-navi__wrap">
                <div class="c-result-date-navi__inner">
                  <!-- 7日間カレンダースクロールボタン(左) -->
                  <ng-container *ngIf="this.deviceTypeFromSize === 'SP'">
                    <button
                      id="roundtrip-flight-availability-international-pres-btn1"
                      class="c-result-date-navi__arrow c-result-date-navi__arrow--prev"
                      [ngClass]="{ 'is-available': !hideLeftBtn }"
                      [attr.aria-label]="'alt.switchToLeftScreen2' | staticMsg"
                      (throttleClick$)="leftSlider($event, boundIndex)"
                      aswThrottleClick
                    >
                      <img
                        src="assets/images/btn_arrow_prev_36.svg"
                        width="36"
                        height="36"
                        alt="{{ 'alt.switchToLeftScreen2' | staticMsg }}"
                        aria-hidden="true"
                      />
                    </button>
                  </ng-container>

                  <!-- ボタン表示部を表示 -->
                  <asw-common-slider id="airCalendar-slider-{{ boundIndex }}" [isAirCalendarSlider]="true">
                    <div class="p-plan-table__scroll-view" id="scrollPanel-{{ boundIndex }}" #scrollPanel>
                      <div class="c-result-date-navi u-mt-sp-16 u-mt-tb-32 u-mt-pc-40">
                        <ng-container *ngFor="let airCalendar of bound.airCalendarList; index as calendarIndex">
                          <!-- カレンダー選択 -->
                          <button
                            #scrollItemList
                            id="c-result-date-navi-btn-{{ calendarIndex }}"
                            class="c-result-date-navi__btn"
                            [class.is-selected]="airCalendar.isSelected"
                            [disabled]="airCalendar.isDisabled || !airCalendar.price"
                            (click)="selectCalendar(boundIndex, calendarIndex)"
                          >
                            <span class="c-result-date-navi__box">
                              <span
                                class="u-visually-hidden"
                                [innerHTML]="'reader.boundNumber' | staticMsg : { '0': boundIndex + 1 }"
                              ></span>
                              <ng-container *ngIf="airCalendar.isSelected">
                                <span
                                  class="u-visually-hidden"
                                  [innerHTML]="'reader.7daysLowestFare' | staticMsg"
                                ></span>
                              </ng-container>
                              <!-- 出発日 -->
                              <ng-container *ngIf="airCalendar.date !== undefined">
                                <span
                                  [innerHTML]="airCalendar.date | dateFormat : 'departuredate_SevenDaysCalendar'"
                                ></span>
                              </ng-container>
                              <!-- 最安支払総額 -->
                              <ng-container *ngIf="airCalendar.price">
                                <span
                                  class="c-result-date-navi__btn-price"
                                  [innerHTML]="airCalendar.price | amountFormat : 'default'"
                                ></span>
                              </ng-container>
                              <ng-container *ngIf="!airCalendar.isdateInfo">
                                <span
                                  class="c-result-date-navi__btn-price"
                                  [innerHTML]="'label.symbolBetweenTime' | staticMsg"
                                ></span>
                              </ng-container>
                              <ng-container *ngIf="airCalendar.isdateInfo && !airCalendar.price">
                                <span
                                  class="c-result-date-navi__btn-price"
                                  [innerHTML]="'label.noVacancy1' | staticMsg"
                                ></span>
                              </ng-container>
                            </span>
                          </button>
                        </ng-container>
                      </div>
                    </div>
                  </asw-common-slider>
                  <!-- 7日間カレンダースクロールボタン(右) -->
                  <ng-container *ngIf="this.deviceTypeFromSize === 'SP'">
                    <button
                      id="roundtrip-flight-availability-international-pres-btn2"
                      class="c-result-date-navi__arrow c-result-date-navi__arrow--next"
                      [ngClass]="{ 'is-available': !hideRightBtn }"
                      [attr.aria-label]="'alt.switchToRightScreen2' | staticMsg"
                      (throttleClick$)="rightSlider($event, boundIndex)"
                      aswThrottleClick
                    >
                      <img
                        src="assets/images/btn_arrow_next_36.svg"
                        width="36"
                        height="36"
                        alt="{{ 'alt.switchToRightScreen2' | staticMsg }}"
                        aria-hidden="true"
                      />
                    </button>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <!-- 7日間カレンダー end -->

          <!-- 検索結果リスト(PC) start -->
          <ng-container *ngIf="this.isPcDevice">
            <div class="p-vacant-seat01">
              <div class="p-vacant-seat01__heading">
                <!-- プロモーション適用凡例 start -->
                <ng-container *ngIf="bound.isPromotionApplied">
                  <div class="p-vacant-seat01__promotion-applied" aria-hidden="true">
                    <span class="c-promotion-applied">
                      <img
                        class="c-promotion-applied__img"
                        src="assets/images/icon_promotion_applied_20.svg"
                        width="20"
                        height="20"
                        alt=""
                      />
                      <span class="c-promotion-applied__text" [innerHTML]="'label.promotionApplied' | staticMsg"></span>
                    </span>
                  </div>
                </ng-container>
                <!-- プロモーション適用凡例 end -->

                <!-- FFヘッダ start -->
                <ng-container *ngIf="bound?.ffHeader?.length ?? -1 > 0">
                  <div class="p-vacant-seat01__heading-left">
                    <!-- FF情報 項目名  -->
                    <button
                      id="p-vacant-seat01-overview-btn"
                      class="p-vacant-seat01__overview-btn js-fare-overview-btn"
                      [ngClass]="{ 'is-open': this.isOpenFareOverview[boundIndex] }"
                      aria-expanded="true"
                      aria-controls="overview-heading fare1 fare2 fare3 fare4 fare5 fare6"
                      (click)="clickFareOverview(boundIndex)"
                    >
                      <!-- FF概要表示切替リンク open -->
                      <ng-container *ngIf="this.isOpenFareOverview[boundIndex] === false">
                        <span
                          class="p-vacant-seat01__view-text"
                          [innerHTML]="'label.fareOverview.open' | staticMsg"
                        ></span>
                      </ng-container>

                      <!-- FF概要表示切替リンク close  -->
                      <ng-container *ngIf="this.isOpenFareOverview[boundIndex] === true">
                        <span
                          class="p-vacant-seat01__view-text"
                          [innerHTML]="'label.fareOverview.close' | staticMsg"
                        ></span>
                      </ng-container>
                    </button>
                    <div
                      id="overview-heading"
                      class="p-vacant-seat01__overview-heading p-vacant-seat01__overview-heading{{ boundIndex }}"
                      [ngClass]="{ 'is-open': this.isOpenFareOverview[boundIndex] }"
                      aria-hidden="true"
                    >
                      <!-- Change -->
                      <div class="p-vacant-seat01__overview-item">
                        <div
                          class="p-vacant-seat01__overview-item-text p-vacant-seat01__overview-item-text--heading"
                          [innerHTML]="'label.changeItinerary' | staticMsg"
                        ></div>
                      </div>
                      <!-- Refund -->
                      <div class="p-vacant-seat01__overview-item">
                        <div
                          class="p-vacant-seat01__overview-item-text p-vacant-seat01__overview-item-text--heading"
                          [innerHTML]="'label.refund' | staticMsg"
                        ></div>
                      </div>
                      <!-- Free checked baggage -->
                      <ng-container *ngIf="bound.ffHeader?.[boundIndex]?.ffInfo?.ffOverview?.freeCheckedBaggage">
                        <div class="p-vacant-seat01__overview-item">
                          <div
                            class="p-vacant-seat01__overview-item-text p-vacant-seat01__overview-item-text--heading"
                            [innerHTML]="'label.freeBaggage1' | staticMsg"
                          ></div>
                        </div>
                      </ng-container>
                      <!-- Seat Select -->
                      <div class="p-vacant-seat01__overview-item">
                        <div
                          class="p-vacant-seat01__overview-item-text p-vacant-seat01__overview-item-text--heading"
                          [innerHTML]="'label.asr' | staticMsg"
                        ></div>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <div class="p-vacant-seat01__heading-right">
                  <!-- FF情報 start -->
                  <div class="p-vacant-seat01__heading-wrap">
                    <div class="p-vacant-seat01__heading-class js-class-head">
                      <ng-container *ngFor="let ffHeader of bound.ffHeader; index as headListIndex">
                        <div *ngIf="ffHeader.ffInfo?.cabinClass" class="p-vacant-seat01__heading-class js-class-head">
                          <div
                            #cabinClassHeadList
                            [id]="getCabinClassHeaderId(boundIndex, headListIndex)"
                            [attr.data-bound-index]="boundIndex"
                            [attr.data-index]="headListIndex"
                            class="p-vacant-seat01__heading-title"
                            aria-hidden="true"
                          >
                            <!-- キャビンクラス -->
                            {{ ffHeader.ffInfo?.cabinClass }}
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="p-vacant-seat01__heading-list">
                      <ng-container *ngFor="let ffHeader of bound.ffHeader; let ffHeaderIndex = index">
                        <div
                          [id]="getTealiumFFHeaderId(boundIndex, ffHeaderIndex)"
                          class="p-vacant-seat01__heading-item p-vacant-seat01__heading_custom p-vacant-seat01__heading-item--{{
                            ffHeader.ffInfo?.ffBand
                          }}"
                          [ngClass]="{
                            'p-vacant-seat01__heading-item--international-first-domestic':
                              (tripTypeList[boundIndex] === 'domestic' &&
                                ffHeader.ffInfo?.ffBand === 'international-first') ||
                              (tripTypeList[boundIndex] === 'domestic' && ffHeader.ffInfo?.ffBand === 'domestic-first')
                          }"
                        >
                          <div
                            #fareFamilyNameList
                            [id]="getFareFamilyNameId(boundIndex, ffHeaderIndex)"
                            [attr.data-bound-index]="boundIndex"
                            [attr.data-index]="ffHeaderIndex"
                            [ngClass]="{ 'js-class-top': ffHeader.ffLinkShowFlg }"
                            class="p-vacant-seat01__heading-fare"
                          >
                            <span class="u-visually-hidden">{{ ffHeader.ffInfo?.cabinClass }}</span>
                            <!-- FF名称 -->
                            {{ ffHeader.ffInfo?.ffName }}
                          </div>
                          <div
                            id="fare1"
                            class="p-vacant-seat01__overview-contents p-vacant-seat01__overview-contents{{
                              boundIndex
                            }}"
                            [ngClass]="{ 'is-open': this.isOpenFareOverview[boundIndex] }"
                          >
                            <!-- 予約変更可否 -->
                            <div class="p-vacant-seat01__overview-item">
                              <span class="u-visually-hidden" [innerHTML]="'label.changeItinerary' | staticMsg"></span>
                              <div
                                class="p-vacant-seat01__overview-item-text"
                                [innerHTML]="ffHeader.ffInfo?.ffOverview?.possibilityChangeItinerary ?? '' | staticMsg"
                              ></div>
                            </div>
                            <!-- 払戻可否 -->
                            <div class="p-vacant-seat01__overview-item">
                              <span class="u-visually-hidden" [innerHTML]="'label.refund' | staticMsg"></span>
                              <div
                                class="p-vacant-seat01__overview-item-text"
                                [innerHTML]="ffHeader.ffInfo?.ffOverview?.possibilityRefund ?? '' | staticMsg"
                              ></div>
                            </div>
                            <!-- 無料預け入れ手荷物個数 -->
                            <ng-container *ngIf="ffHeader.ffInfo?.ffOverview?.freeCheckedBaggage">
                              <ng-container
                                *ngIf="
                                  ffHeader.ffInfo?.ffOverview?.valueFreeBaggage !== '0' &&
                                  ffHeader.ffInfo?.ffOverview?.valueFreeBaggage !== '-'
                                "
                              >
                                <div class="p-vacant-seat01__overview-item">
                                  <span class="u-visually-hidden" [innerHTML]="'label.freeBaggage' | staticMsg"></span>
                                  <div
                                    class="p-vacant-seat01__overview-item-text"
                                    [innerHTML]="
                                      'label.pcs' | staticMsg : { '0': ffHeader.ffInfo?.ffOverview?.valueFreeBaggage }
                                    "
                                  ></div>
                                </div>
                              </ng-container>
                              <ng-container *ngIf="ffHeader.ffInfo?.ffOverview?.valueFreeBaggage === '-'">
                                <div class="p-vacant-seat01__overview-item">
                                  <span class="u-visually-hidden" [innerHTML]="'label.freeBaggage' | staticMsg"></span>
                                  <div
                                    class="p-vacant-seat01__overview-item-text"
                                    [innerHTML]="'label.symbolBetweenTime' | staticMsg"
                                  ></div>
                                </div>
                              </ng-container>
                            </ng-container>
                            <!-- (11-9) 座席指定料金 -->
                            <!-- 座席指定可(有料) -->
                            <ng-container *ngIf="ffHeader.ffInfo?.ffOverview?.seatReservationFee === 'chargeable'">
                              <div class="p-vacant-seat01__overview-item">
                                <span class="u-visually-hidden" [innerHTML]="'label.asr' | staticMsg"></span>
                                <div
                                  class="p-vacant-seat01__overview-item-text"
                                  [innerHTML]="'label.chargeableSeatAssign1' | staticMsg"
                                ></div>
                              </div>
                            </ng-container>
                            <!-- 座席指定可(無料) -->
                            <ng-container *ngIf="ffHeader.ffInfo?.ffOverview?.seatReservationFee === 'included'">
                              <div class="p-vacant-seat01__overview-item">
                                <span class="u-visually-hidden" [innerHTML]="'label.asr' | staticMsg"></span>
                                <div
                                  class="p-vacant-seat01__overview-item-text"
                                  [innerHTML]="'label.requestSeat.availableFree' | staticMsg"
                                ></div>
                              </div>
                            </ng-container>
                            <!-- 座席指定不可 -->
                            <ng-container *ngIf="ffHeader.ffInfo?.ffOverview?.seatReservationFee === 'notOffered'">
                              <div class="p-vacant-seat01__overview-item">
                                <span class="u-visually-hidden" [innerHTML]="'label.asr' | staticMsg"></span>
                                <div
                                  class="p-vacant-seat01__overview-item-text"
                                  [innerHTML]="'label.asr.chargeableType.impossible' | staticMsg"
                                ></div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <!-- FF情報 end -->
                </div>
                <!-- FFヘッダ end -->
              </div>

              <!-- TSリスト start -->
              <div class="p-vacant-seat01__body" #tsList>
                <!-- フライトサマリ start -->
                <ng-container *ngFor="let tsList of bound.tsList; index as tsListIndex">
                  <div
                    class="p-vacant-seat01__item js-flight-item"
                    [ngClass]="{ 'p-vacant-seat01__item--unavailable': !tsList.flightSummaryAvailableFlag }"
                  >
                    <div [id]="getTealiumFlightSummaryId(boundIndex, tsListIndex)" class="p-vacant-seat01__flight">
                      <!-- フライトサマリ -->
                      <asw-flight-plan
                        *ngIf="tsList.flightSummary"
                        [isSelected]="false"
                        [flightSummary]="tsList.flightSummary"
                        [boundIndex]="boundIndex"
                        [tsListIndex]="tsListIndex"
                        [isOpenFlightDetail]="this.isOpenFlightDetail(boundIndex, tsListIndex)"
                        (openFlightDetailModalEvent)="this.openFlightDetailModal(boundIndex, tsListIndex)"
                        (changeOpenFlightDetailEvent)="this.changeOpenFlightDetail(boundIndex, tsListIndex)"
                      >
                      </asw-flight-plan>
                    </div>

                    <!-- フライト詳細 start -->
                    <div
                      class="p-vacant-seat01__detail js-flight-detail-contents"
                      [ngClass]="{ 'is-open': this.isOpenFlightDetail(boundIndex, tsListIndex) }"
                      id="flight-detail-{{ boundIndex }}-{{ tsListIndex }}"
                    >
                      <asw-flight-detail
                        [flightDetailHeader]="tsList.flightDetailHeader ?? {}"
                        [flightDetailSegment]="tsList.flightDetailSegment ?? []"
                      >
                      </asw-flight-detail>
                    </div>
                    <!-- フライト詳細 end -->

                    <!-- TS別FF情報 start -->
                    <div class="p-vacant-seat01__cells">
                      <!-- TS別FF情報ループ開始 -->
                      <ng-container *ngFor="let tsffInfo of tsList.tsffInfo; index as tsffInfoIndex">
                        <ng-container *ngIf="tsffInfo.isAvailable && (tsffInfo.price ?? 0) > 0">
                          <div
                            [id]="getTealiumTSFFListId(boundIndex, tsListIndex, tsffInfoIndex)"
                            class="p-vacant-seat01__cell"
                            [class.p-vacant-seat01__cell--selected]="tsffInfo.isSelected"
                          >
                            <div
                              class="p-vacant-seat01__btn"
                              role="button"
                              tabindex="0"
                              (throttleClick$)="this.openFareFamilySelectorModal(boundIndex, tsList, tsListIndex)"
                              aswThrottleClick
                            >
                              <!-- フライトサマリ全体(フライト詳細表示除く)と、FFヘッダのキャビンクラス、FF名称を読み上げ -->
                              <span
                                class="u-visually-hidden"
                                [attr.aria-labelledby]="
                                  getTealiumFlightSummaryId(boundIndex, tsListIndex) +
                                  ' ' +
                                  getLabelledByCabinClassId(boundIndex, tsffInfoIndex) +
                                  ' ' +
                                  getFareFamilyNameId(boundIndex, tsffInfoIndex)
                                "
                              ></span>
                              <!-- FF選択モーダルが表示される旨の読み上げ -->
                              <span
                                class="u-visually-hidden"
                                [innerHTML]="'reader.openFareSelectmodel' | staticMsg"
                              ></span>
                              <!-- プロモーション適用有無のマーク -->
                              <ng-container *ngIf="tsffInfo.isPromotionApplied">
                                <span class="p-vacant-seat01__btn-promotion">
                                  <span class="c-promotion-applied">
                                    <img
                                      class="c-promotion-applied__img"
                                      src="assets/images/icon_promotion_applied_20.svg"
                                      width="20"
                                      height="20"
                                      alt="{{ 'reader.promotionIconDisplay' | staticMsg }}"
                                    />
                                  </span>
                                </span>
                              </ng-container>

                              <div class="p-vacant-seat01__btn-inner">
                                <!-- 最低価格の場合ラベルの追加 -->
                                <ng-container *ngIf="tsffInfo.isLowestPrice">
                                  <div class="p-vacant-seat01__btn-lowest">
                                    <span
                                      class="c-tag-lowest-price"
                                      [innerHTML]="'label.lowestprice1' | staticMsg"
                                    ></span>
                                  </div>
                                </ng-container>
                                <div class="p-vacant-seat01__btn-price">
                                  <em>
                                    <!-- 金額 -->
                                    <span
                                      class="p-vacant-seat01__btn-price-num"
                                      [innerHTML]="
                                        tsffInfo.price ?? 0 | amountFormat : 'availability.vacantSeat_totalPrice'
                                      "
                                    ></span>
                                  </em>
                                </div>
                                <div class="p-vacant-seat01__btn-info">
                                  <ng-container *ngIf="tsffInfo.isPromotionApplied">
                                    <div class="p-vacant-seat01__btn-del">
                                      <!-- プロモーション適用前金額 -->
                                      <del
                                        [innerHTML]="
                                          tsffInfo.originalPrice ?? 0
                                            | amountFormat : 'availability.vacantSeat_beforePrice'
                                        "
                                      ></del>
                                    </div>
                                  </ng-container>
                                  <div class="p-vacant-seat01__btn-del">
                                    <!-- (15-6) 残席数 -->
                                    <em
                                      *ngIf="tsffInfo.quotaType === 'few'"
                                      [innerHTML]="'label.lastSeatWithSpan1' | staticMsg : { '0': tsffInfo.quota ?? 0 }"
                                    ></em>
                                    <em
                                      *ngIf="tsffInfo.quotaType === 'available'"
                                      [innerHTML]="'label.existsSeat' | staticMsg"
                                    ></em>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <!-- 利用不可の場合 -->
                        <ng-container *ngIf="!tsffInfo.isAvailable || (tsffInfo.price ?? 0) < 1">
                          <div
                            class="p-vacant-seat01__cell p-vacant-seat01__cell--unavailable"
                            [ngStyle]="tsffInfoIndex !== 0 ? { 'border-left': '1px solid #b2b2b2' } : {}"
                          >
                            <div class="p-vacant-seat01__btn">
                              <!-- フォーカスが当たらないため、フライトサマリなどの読み上げは無い -->
                              <!-- 利用不可のため、FF選択モーダルが表示される旨の文言は出さない -->
                              <div class="p-vacant-seat01__btn-inner">
                                <div
                                  class="p-vacant-seat01__btn-text"
                                  [innerHTML]="'label.noVacancy1' | staticMsg"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
                <!-- フライトサマリ end -->
              </div>
              <!-- TSリスト end -->
            </div>
          </ng-container>
          <!-- 検索結果リスト(PC) end -->

          <!-- SP・TAB版かつFF未選択 start -->
          <ng-container *ngIf="!this.isPcDevice">
            <!-- プロモーション適用凡例 start -->
            <ng-container *ngIf="bound.isPromotionApplied">
              <div class="c-promotion-applied u-mt-tb-24 u-mt-sp-20" aria-hidden="true">
                <span class="c-promotion-applied">
                  <img
                    class="c-promotion-applied__img"
                    src="assets/images/icon_promotion_applied_20.svg"
                    width="20"
                    height="20"
                    alt=""
                  />
                  <span class="c-promotion-applied__text" [innerHTML]="'label.promotionApplied' | staticMsg"></span>
                </span>
              </div>
            </ng-container>
            <!-- プロモーション適用凡例 end -->
            <span #tsListNotPC>
              <ng-container *ngFor="let tsList of bound.tsList; index as tsListIndex">
                <asw-flight-summary-and-fare-family
                  [isSelected]="false"
                  [flightSummary]="tsList.flightSummary ?? this.settingFlightSummary"
                  [selectTSFFInfo]="bound.selectTSFFInfo"
                  [tsList]="tsList"
                  [tsffInfos]="tsList.tsffInfo"
                  [boundIndex]="boundIndex"
                  [tsListIndex]="tsListIndex"
                  [isOpenFlightDetail]="this.isOpenFlightDetail(boundIndex, tsListIndex)"
                  [isTealiumAvailable]="true"
                  (openFlightDetailModalEvent)="this.openFlightDetailModal(boundIndex, tsListIndex)"
                  (changeOpenFlightDetailEvent)="this.changeOpenFlightDetail(boundIndex, tsListIndex)"
                  (yPosition)="this.getYPosition($event, boundIndex, tsListIndex)"
                  (openFareFamilySelectorModalEvent)="this.openFareFamilySelectorModal(boundIndex, tsList, tsListIndex)"
                ></asw-flight-summary-and-fare-family>
              </ng-container>
            </span>
          </ng-container>
          <!-- SP・TAB版かつFF未選択 end -->
        </ng-container>

        <!-- 選択済の場合 -->
        <ng-container *ngIf="bound.isShowSelectedTsAndFf">
          <!-- プロモーション適用凡例 start -->
          <ng-container *ngIf="bound.isPromotionApplied">
            <div class="c-promotion-applied u-mt-tb-24 u-mt-sp-20" aria-hidden="true">
              <span class="c-promotion-applied">
                <img
                  class="c-promotion-applied__img"
                  src="assets/images/icon_promotion_applied_20.svg"
                  width="20"
                  height="20"
                  alt=""
                />
                <span class="c-promotion-applied__text" [innerHTML]="'label.promotionApplied' | staticMsg"></span>
              </span>
            </div>
          </ng-container>
          <!-- プロモーション適用凡例 end -->

          <!-- 選択中TS・FF情報(PC,TAB,SP共通) -->
          <asw-flight-summary-and-fare-family
            #tsList
            [isSelected]="true"
            [flightSummary]="bound.selectTSFFInfo?.flightSummary ?? this.settingFlightSummary"
            [selectTSFFInfo]="bound.selectTSFFInfo"
            [tsList]="bound.tsList?.[bound.selectTSFFInfo?.tsListIndex ?? 0]"
            [boundIndex]="boundIndex"
            [tsListIndex]="bound.selectTSFFInfo?.tsListIndex ?? 0"
            [isOpenFlightDetail]="this.isOpenFlightDetail(boundIndex, bound.selectTSFFInfo?.tsListIndex ?? 0)"
            (openFlightDetailModalEvent)="
              this.openFlightDetailModal(boundIndex, bound.selectTSFFInfo?.tsListIndex ?? 0)
            "
            (changeOpenFlightDetailEvent)="
              this.changeOpenFlightDetail(boundIndex, bound.selectTSFFInfo?.tsListIndex ?? 0)
            "
            (yPosition)="this.getYPosition($event, boundIndex, bound.selectTSFFInfo?.tsListIndex ?? 0)"
            (openFareFamilySelectorModalEvent)="
              this.openFareFamilySelectorModal(boundIndex, bound.tsList?.[bound.selectTSFFInfo?.tsListIndex ?? 0] ?? {}, bound.selectTSFFInfo?.tsListIndex ?? 0)
            "
          ></asw-flight-summary-and-fare-family>

          <div class="p-btn-area01">
            <div class="p-btn-area01__item">
              <button
                id="c-btn-show-{{ boundIndex }}"
                class="c-btn-show"
                (throttleClick$)="this.clickShowOtherFlightsButton(boundIndex)"
                aswThrottleClick
              >
                <span class="c-btn-show__text" [innerHTML]="'label.showOtherFlight' | staticMsg"></span>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <!-- バウンドリスト end -->
    <!-- 区間の描画ループここまで -->

    <!-- 検索日時 -->
    <div class="l-section">
      <div class="p-date-display01">
        <div class="p-date-display01__time">{{ this.searchDateTimeString | dateFormat : 'default_currentDate' }}</div>
      </div>
    </div>
  </div>
  <!-- [コンテンツ領域フルカラム−メイン] -->
</div>

<!-- [コンテンツ領域] -->
<!-- 検索結果フッター -->
<!-- [画面下部固定フローティングナビ] -->
<ng-container>
  <div class="l-bottom-float">
    <ng-container *ngIf="this.deviceTypeFromSize === 'SP'">
      <div class="p-bottom-float-function-icon">
        <ng-container *ngIf="this.isSearchResultOfSpecifiedDate">
          <div class="p-bottom-float-function-icon__item p-bottom-float-function-icon__item--left01">
            <button
              id="roundtrip-flight-availability-international-pres-button1"
              class="p-bottom-float-function-icon__btn"
              title="{{ 'alt.searchConditionsFilter' | staticMsg }}"
              (throttleClick$)="this.openFilterConditionModal()"
              aswThrottleClick
            >
              <img
                src="assets/images/icon_filter_primary_20.svg"
                width="20"
                height="20"
                alt="{{ 'alt.searchConditionsFilter' | staticMsg }}"
                aria-hidden="true"
              />
            </button>
          </div>
          <div class="p-bottom-float-function-icon__item p-bottom-float-function-icon__item--left02">
            <button
              id="roundtrip-flight-availability-international-pres-button2"
              class="p-bottom-float-function-icon__btn"
              title="{{ 'alt.searchConditionsSort' | staticMsg }}"
              (throttleClick$)="this.openSortConditonModal()"
              aswThrottleClick
            >
              <img
                src="assets/images/icon_sort_primary_20.svg"
                width="20"
                height="20"
                alt="{{ 'alt.searchConditionsSort' | staticMsg }}"
                aria-hidden="true"
              />
            </button>
          </div>
        </ng-container>
        <div
          class="p-bottom-float-function-icon__item p-bottom-float-function-icon__item--right01"
          *ngIf="getLoginStatus()"
        >
          <asw-add-to-favorite
            [isRegisteredFavorite]="getIsRegisteredFavorite()"
            (clickFavoriteEvent)="this.addFavorite()"
          ></asw-add-to-favorite>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="this.deviceTypeFromSize === 'TAB'">
      <div class="p-bottom-float-function-icon p-bottom-float-function-icon--pattern01">
        <div
          class="p-bottom-float-function-icon__item p-bottom-float-function-icon__item--right01"
          *ngIf="getLoginStatus()"
        >
          <asw-add-to-favorite
            [isRegisteredFavorite]="getIsRegisteredFavorite()"
            (clickFavoriteEvent)="this.addFavorite()"
          ></asw-add-to-favorite>
        </div>
      </div>
    </ng-container>
    <!-- [PC/TAB用 下部固定エリア内金額表示エリア] -->
    <div
      class="p-bottom-float-navi02 p-bottom-float-navi02--has-promotion"
      *ngIf="this.isShowFooter && this.deviceTypeFromSize !== 'SP'"
    >
      <div class="p-bottom-float-navi02__wrap">
        <div class="p-bottom-float-navi02__inner">
          <div class="p-bottom-float-navi02__item">
            <div class="p-bottom-float-navi02__detail">
              <ng-container *ngIf="this.selectedAirOffer?.isPromotionApplied">
                <div class="p-bottom-float-navi02__detail-promotion">
                  <!-- プロモーション適用済アイコン -->
                  <span class="c-promotion-applied">
                    <img
                      class="c-promotion-applied__img"
                      src="assets/images/icon_promotion_applied_20.svg"
                      width="20"
                      height="20"
                      alt="{{ 'reader.promotionIconDisplay' | staticMsg }}"
                  /></span>
                </div>
              </ng-container>
              <div class="p-bottom-float-navi02__detail-price">
                <!-- 支払総額 -->
                <em>
                  <span
                    [innerHTML]="
                      this.selectedAirOffer?.price ?? 0 | amountFormat : 'availability.bottomFloat_totalPrice'
                    "
                  ></span>
                </em>
              </div>
              <div class="p-bottom-float-navi02__detail-link">
                <!-- 金額内訳モーダル表示リンク -->
                <a
                  id="amount-breakdown"
                  href="#"
                  class="c-text-link-arrow01 c-text-link-arrow01--ss"
                  (throttleClick$)="this.openPaymentDetailModal($event)"
                  [innerHTML]="'label.details2' | staticMsg"
                  aswThrottleClick
                ></a>
              </div>
              <ng-container *ngIf="this.selectedAirOffer?.originalPriceNumber">
                <!-- プロモーション適用前金額 -->
                <div class="p-bottom-float-navi02__detail-del">
                  <del [innerHTML]="this.selectedAirOffer?.originalPriceNumber ?? 0 | amountFormat"></del>
                </div>
              </ng-container>
              <div
                class="p-bottom-float-navi02__detail-info"
                [innerHTML]="'label.includeFareAndFuelCost' | staticMsg"
              ></div>
            </div>
          </div>
          <div class="p-bottom-float-navi02__item">
            <ng-container *ngIf="this.selectedAirOffer?.accrualMiles">
              <!-- 積算マイル -->
              <div
                class="p-bottom-float-navi02__miles"
                [innerHTML]="
                  'label.colonFlightmiles'
                    | staticMsg : { '0': this.selectedAirOffer?.accrualMiles ?? 0 | amountFormat : 'default' : 'MIL' }
                "
              ></div>
            </ng-container>
            <!-- 次へボタン -->
            <button
              id="bottom-float-navi-proceed-btn2"
              class="c-btn-primary c-btn-primary--min-w100 c-btn-primary--sp-s"
              [disabled]="this.activeFooterBtn"
              (click)="this.clickNextFlow($event)"
            >
              <span class="c-btn-primary__text" [innerHTML]="'label.proceed' | staticMsg"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="p-bottom-float-navi03 p-bottom-float-navi03--has-promotion"
      *ngIf="this.isShowFooter && this.deviceTypeFromSize === 'SP'"
    >
      <div class="p-bottom-float-navi03__miles" *ngIf="this.existsAccrualMiles()">
        <!-- 積算マイル -->
        <ng-container>
          <div
            class="p-bottom-float-navi03__miles-inner"
            [innerHTML]="
              'label.colonFlightmiles'
                | staticMsg : { '0': this.selectedAirOffer?.accrualMiles ?? 0 | amountFormat : 'default' : 'MIL' }
            "
          ></div>
        </ng-container>
      </div>
      <div class="p-bottom-float-navi03__wrap">
        <div class="p-bottom-float-navi03__inner">
          <div class="p-bottom-float-navi03__item">
            <div class="p-bottom-float-navi03__detail">
              <ng-container *ngIf="this.selectedAirOffer?.isPromotionApplied">
                <div class="p-bottom-float-navi03__detail-promotion">
                  <!-- プロモーション適用済アイコン -->
                  <span class="c-promotion-applied">
                    <img
                      class="c-promotion-applied__img"
                      src="assets/images/icon_promotion_applied_20.svg"
                      width="20"
                      height="20"
                      alt="{{ 'reader.promotionIconDisplay' | staticMsg }}"
                    />
                  </span>
                </div>
              </ng-container>
              <div class="p-bottom-float-navi03__detail-price">
                <!-- 支払総額 -->
                <em>
                  <span
                    [innerHTML]="
                      this.selectedAirOffer?.price ?? 0 | amountFormat : 'availability.bottomFloat_totalPrice'
                    "
                  ></span>
                </em>
              </div>
              <div class="p-bottom-float-navi03__detail-link">
                <!-- 金額内訳モーダル表示リンク -->
                <a
                  id="amount-breakdown2"
                  href="#"
                  class="c-text-link-arrow01 c-text-link-arrow01--ss"
                  (throttleClick$)="this.openPaymentDetailModal($event)"
                  [innerHTML]="'label.details2' | staticMsg"
                  aswThrottleClick
                ></a>
              </div>
              <ng-container *ngIf="this.selectedAirOffer?.originalPriceNumber">
                <!-- プロモーション適用前金額 -->
                <div class="p-bottom-float-navi03__detail-del">
                  <del [innerHTML]="this.selectedAirOffer?.originalPriceNumber ?? 0 | amountFormat"></del>
                </div>
              </ng-container>
              <div
                class="p-bottom-float-navi03__detail-info"
                [innerHTML]="'label.includeFareAndFuelCost' | staticMsg"
              ></div>
            </div>
          </div>
          <div class="p-bottom-float-navi03__item">
            <!-- 次へボタン -->
            <button
              id="bottom-float-navi-proceed-btn"
              class="c-btn-primary c-btn-primary--min-w100 c-btn-primary--sp-s"
              [disabled]="this.activeFooterBtn"
              (click)="this.clickNextFlow($event)"
            >
              <span class="c-btn-primary__text" [innerHTML]="'label.proceed' | staticMsg"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- [PC/TAB用 下部固定エリア内金額表示エリア] -->
  </div>
  <!-- [画面下部固定フローティングナビ] -->
</ng-container>
<asw-criteo-alignment [criteoAlignmentInfo]="criteoAlignmentInfo"></asw-criteo-alignment>
